import React, { useEffect } from "react";

function useTitle(title) {
  useEffect(() => {
    document.title = `${title} - PKSFW3`;
  }, [title]);
}

export default useTitle;
